import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { ReactComponent as More } from 'lib/_content/images/icons/navigation/more.svg';
import { ReactComponent as Help } from 'lib/_content/images/icons/navigation/help.svg';
import { ReactComponent as Card } from 'lib/_content/images/icons/navigation/cards.svg';
import { ReactComponent as Payment } from 'lib/_content/images/icons/navigation/payment.svg';
import { ReactComponent as Home } from 'lib/_content/images/icons/navigation/home.svg';
import { ReactComponent as MoreActive } from 'lib/_content/images/icons/navigation/active/more-active.svg';
import { ReactComponent as HelpActive } from 'lib/_content/images/icons/navigation/active/help-active.svg';
import { ReactComponent as CardActive } from 'lib/_content/images/icons/navigation/active/cards-active.svg';
import { ReactComponent as PaymentActive } from 'lib/_content/images/icons/navigation/active/payment-active.svg';
import { ReactComponent as HomeActive } from 'lib/_content/images/icons/navigation/active/home-active.svg';
import Curve from 'lib/_content/images/icons/navigation-curve.png';
import CurveDark from 'lib/_content/images/icons/navigation-curve-dark.png';
import { useSelector } from 'react-redux';
import { getTheme } from 'selectors/darkMode';
import useTranslate from 'lib/languages/useTranslate';

const TabNavbar = () => {
    const { pathname } = useLocation();
    const isDarkModeEnabled = useSelector(getTheme);

    const translate = useTranslate('bottomTabs');

    const navlinks = [
        {
            name: translate('home'),
            icon: Home,
            activeIcon: HomeActive,
            route: '/',
        },
        {
            name: translate('cards'),
            icon: Card,
            activeIcon: CardActive,
            route: '/cards',
        },
        {
            name: translate('payments'),
            icon: Payment,
            activeIcon: PaymentActive,
            route: '/payments',
            activeRoutes: ['payments', 'international'],
        },
        {
            name: translate('help'),
            icon: Help,
            activeIcon: HelpActive,
            route: '/help',
        },
        {
            name: translate('more'),
            icon: More,
            activeIcon: MoreActive,
            route: '/more',
        },
    ];

    return (
        <ul className="nav-links">
            {navlinks.map(({ name, icon, activeIcon, route, activeRoutes }) => {
                const formattedRouteName =
                    route.toLowerCase().split('/')[1] || '/';
                const formattedPathName =
                    pathname.toLowerCase().split('/')[1] || '/';
                const isActiveRoutes = activeRoutes
                    ? activeRoutes.includes(formattedPathName)
                    : null;
                const isActive =
                    isActiveRoutes ||
                    formattedPathName.includes(formattedRouteName);

                const IconSvg = icon;
                const ActiveIconSvg = activeIcon;

                return (
                    <li key={name} className={isActive ? 'active' : ''}>
                        <img
                            className="curve"
                            alt="curve"
                            src={isDarkModeEnabled ? CurveDark : Curve}
                        />
                        <Link to={route} className="link-icon">
                            <span>
                                {isActive && !isDarkModeEnabled ? (
                                    <ActiveIconSvg width="25" height="25" />
                                ) : (
                                    <IconSvg
                                        width="25"
                                        height="25"
                                        className="no-active-icon"
                                    />
                                )}
                                <p>{name}</p>
                            </span>
                        </Link>
                    </li>
                );
            })}
        </ul>
    );
};

export default TabNavbar;
